import{css as o}from"@lokalise/styled";import{color as t}from"../theme/index.js";const i=o`
	outline-width: 2px !important;
	outline-style: solid !important;
	outline-color: ${t("primary.500")} !important;
	outline-color: -webkit-focus-ring-color !important;
	outline-offset: 1px !important;
`;export{i as outlineStyle};
//# sourceMappingURL=outlineStyle.js.map
